var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('files-list',{attrs:{"folder-id":_vm.$route.params.itemId,"publicItems":true},on:{"folder-click":_vm.onFolderClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }